import { checkIsBusinessUser } from "selectors/user";
import {
  checkSelectedBusinessHasWhoAsk,
  checkSelectedBusinessRpaMode
} from "selectors/businesses";
import { getActiveOrganization } from "selectors/organizations";
import { getTransactionsStats } from "selectors/transactions";
import { useSelector } from "react-redux";
import DataStatuses from "const/DataStatuses";
import MongoDb from "utils/MongoDb";
import Platforms from "utils/Platforms";
import React, { useMemo } from "react";
import StatusFilter from "nlib/common/StatusFilter";
import TransactionsStatuses from "nlib/pages/TransactionsPage/TransactionsStatuses";
import useEnvVars from "hooks/useEnvVars";

const BUSINESS_STATUSES = [DataStatuses.NEED_REACTION, DataStatuses.TO_REVIEW];

const TransactionsStatusFilter = (props) => {
  const [{ text }] = useEnvVars();

  const rpaMode = useSelector(checkSelectedBusinessRpaMode);

  const selectedBusinessHasWhoAsk = useSelector(checkSelectedBusinessHasWhoAsk);

  const businessUser = useSelector(checkIsBusinessUser);

  const transactionsStats = useSelector(getTransactionsStats);

  const { [DataStatuses.NEED_REACTION]: needReactionCount } = transactionsStats;

  const { businessOrganization } = useSelector(getActiveOrganization);

  const searchByMongoId = !!text && MongoDb.checkIsMongoId(text.replace("activityId:", ""));

  const statusesList = useMemo(() => {
    const list = Object.values(
      TransactionsStatuses.getStatusData([
        undefined,
        businessOrganization,
        rpaMode && !selectedBusinessHasWhoAsk,
        businessUser
      ])
    );

    return list.filter(({ value }) => businessUser
      ? BUSINESS_STATUSES.includes(value)
      : ((value !== DataStatuses.NEED_DOCUMENT || rpaMode)
        && (value !== DataStatuses.NEED_REACTION || rpaMode || selectedBusinessHasWhoAsk || needReactionCount))
        && (value !== DataStatuses.IN_PROGRESS || (rpaMode && !Platforms.checkIsTouchDevice())));
  }, [businessOrganization, businessUser, rpaMode, selectedBusinessHasWhoAsk, needReactionCount]);

  return (
    <StatusFilter
      {...props}
      defaultValue={!searchByMongoId && (businessUser ? DataStatuses.NEED_REACTION : null)}
      statusesList={statusesList}
      stats={transactionsStats} />
  );
};

export default React.memo(TransactionsStatusFilter);
